import React, { Component, useEffect, useState } from 'react'
import { Form, Input, Button, Checkbox, PageHeader, Select, Breadcrumb, Divider, Row, Col } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import { Link } from 'react-router-dom';
import { TabletFilled } from '@ant-design/icons';
import history from '../../../history';
import CommonForm, { renderCheckbox, renderInput, renderSelect, renderTextField } from '../../../component/form/form';
import { connect } from 'react-redux';
import {createNewRole,getRoleById,updateRole} from '../../../actions/role'
const { Option } = Select;
const layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 16 },
  };
  const tailLayout = {
    wrapperCol: { offset: 4, span: 16 },
  };
  const auth = [
    {value: true, label: 'Active'},
    {value: false , label: 'Inactive'},
  ]

const EditRole = ({getRoleById,updateRole,location}) => {
  const [data, setData] = useState(null)
  const [roleId, setRoleId] = useState(null)
  const [roleName, setRoleName] = useState(null)
  const [visible, setVisible] = useState(false)
  const [position, setPosition] = useState('bottom')
  const onFinish = (values) => {
            // console.log('Success:', values);
    updateRole(values,roleName)
  };
   
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  const [form] = Form.useForm();
  
        useEffect(async() => {
          // const res = await getProfile()
          const search = location.search;
          const id = new URLSearchParams(search).get("id");
          setRoleId(id)
          const res = await getRoleById(id)
          setRoleName(res?.name)
          setData(res)
              form.setFieldsValue({
                role: res?.name,
                active: res?.active,
                account_management : res?.role?.account_management,
                app_management : res?.role?.app_management,
                author_management : res?.role?.author_management,
                banner_management : res?.role?.banner_management,
                book_management : res?.role?.book_management,
                publisher_management : res?.role?.publisher_management,
                store_management : res?.role?.store_management,
                support_management : res?.role?.support_management,
                b_user_management : res?.role?.b_user_management,
                user_management : res?.role?.user_management,
                
                // mobile_number: res?.mobile_number,
              });
        }, []);
  return ( 
    <Content>
      <Breadcrumb style={{padding:"10px 0px"}}>
               <Breadcrumb.Item><Link to="/dashboard">Home</Link></Breadcrumb.Item>
               <Breadcrumb.Item>Edit Role</Breadcrumb.Item>
             </Breadcrumb>
             <PageHeader
              ghost={false}
              onBack={() => window.history.back()}
              title="Edit Role"
              subTitle="Role Management"
              extra={[
                <Button key="1"  type="primary" icon={<TabletFilled />} onClick = { () => history.push('/roles')}>Role List
                </Button>,
              ]}
            >
            </PageHeader>
            <br />

      {data ? 
          <Form
            name="basic"
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 16 }}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            style={{alignSelf: 'center'}}
            requiredMark={false}
            form={form}
          >
         
            <Divider orientation="center">Assign role's access</Divider>

            <Row>
                <Col flex="1 1 200px">
                  {renderCheckbox('user_management', 'User Management', [
                      { required: false },
                    ])
                  }
                  {renderCheckbox('b_user_management', 'Book User Management',   [
                      { required: false },
                    ])
                  }
                  {renderCheckbox('account_management', 'Account Management',  [
                      { required: false },
                    ])
                  }
                  {renderCheckbox('app_management', 'App Management',   [
                      { required: false },
                    ])
                  }
                  {renderCheckbox('author_management', 'Author Management', [
                      { required: false },
                    ])
                  }
                  {renderCheckbox('banner_management', 'Banner Management', [
                      { required: false },
                    ])
                  }
                </Col>
                <Col flex="1 1 200px">
                  {renderCheckbox('book_management', 'Book Management', [
                      { required: false },
                    ])
                  }
                  {renderCheckbox('publisher_management', 'Publisher Management',  [
                      { required: false },
                    ])
                  }
                  {renderCheckbox('store_management', 'Store Management', [
                      { required: false },
                    ])
                  }
                  {renderCheckbox('support_management', 'Support Management', [
                      { required: false },
                    ])
                  }
                </Col>
              </Row>
              <Form.Item {...tailLayout}> 
                <Button type="primary" htmlType="submit">
                  Update
                </Button>
              </Form.Item>
          </Form>
          : null}

    </Content>
   );
}
 
// export default EditRole;
 
export default connect(null,{createNewRole,getRoleById,updateRole})(EditRole);